import React from "react";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnSubtitle from "../common/adnSubtitle/AdnSubtitle";
import AdnCard from "../common/adnCard/AdnCard";
import { Form, Row, Col, Space } from "antd";
import { EuroOutlined } from "@ant-design/icons";
import AdnInput from "../common/adnInput/AdnInput";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import { ExperienceOptions, } from "../common/GeneralConfigurations";
import AdnInputNumber from "../common/adnInputNumber/AdnInputNumber";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import {
  AllocationHoursValidation,
  AllocationPercentageValidation,
  ExperienceValidation,
  MemberProfileValidation,
  PriceValidation
} from "./ProjectTeamMemberValidations";

const ProjectTeamMemberForm = ({
  form,
  handleSearchMemberProfile,
  handleSelectMemberProfile,
  searchMemberProfileOptions,
  handleCancel,
  submitProjectTeamMember,
  projectName,
  handleExperienceChange,
}) => {

  return (
    <>
      <AdnPageTitle title={"Add Project Team Member"} />
      <AdnCard>
        <AdnSubtitle text={"Details"} />
        <Form layout="vertical"
          form={form}
          initialValues={{ experience: 2 }}
          onFinish={submitProjectTeamMember}>

          <Row gutter={16}>
            <Col span={8}>
              <AdnInput
                label="Project"
                value={projectName}
              />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Member Profile"
                name={"name"}
                rules={MemberProfileValidation(form)}>

                <AdnAutoComplete
                  placeholder={"Member Profile..."}
                  valueId={"profileDescription"}
                  handleSearch={handleSearchMemberProfile}
                  handleSelect={handleSelectMemberProfile}
                  resultList={searchMemberProfileOptions}
                ></AdnAutoComplete>
              </Form.Item>
            </Col>

            <Col span={3}>
              <AdnDropdown
                label="Experience"
                handleChange={handleExperienceChange}
                options={ExperienceOptions}
                name="experience"
                rules={ExperienceValidation}
              />
            </Col>

            <Col span={6}>
              <AdnInput
                label="Price"
                addonAfter={<EuroOutlined />}
                type={"number"}
                name="price"
                rules={PriceValidation}
              />
            </Col>

            <Col span={3}>
              <AdnInput
                label="AllocationHours"
                type={"number"}
                name="allocationHours"
                rules={AllocationHoursValidation}
              />
            </Col>

            <Col span={4}>
              <AdnInputNumber
                min={0}
                max={100}
                label="AllocationPercentage"
                type={"percentage"}
                name="allocationPercentage"
                rules={AllocationPercentageValidation}
              />
            </Col>

          </Row>
          <Row>
            <Col offset={22} span={2}>
              <AdnFormOptions handleCancel={handleCancel} />
            </Col>
          </Row>
        </Form>
      </AdnCard>
    </>
  );
};

export default ProjectTeamMemberForm;
